<ng-container *ngIf="(results$|async) as results">

  <div class="funnel">
    <dx-funnel
      [dataSource]="(datas$|async)"
      argumentField="argument"
      valueField="value"
      palette="Soft Pastel"
    >
      <dxo-size [width]="600" [height]="400"></dxo-size>
      <dxo-legend [visible]="false"></dxo-legend>

      <dxo-item>
        <dxo-border [visible]="true"></dxo-border>
      </dxo-item>

      <dxo-label
        [visible]="true"
        position="columns"
        backgroundColor="none"
        [customizeText]="customizeText"
      ></dxo-label>

    </dx-funnel>

  </div>

  <div class="details" *ngIf="results?.total > 0">

    <ejs-tab heightAdjustMode='Fill'>

      <e-tabitems>

        <e-tabitem>
          <ng-template #headerText>
            <div>Details</div>
          </ng-template>
          <ng-template #content>
            <ng-container [ngTemplateOutlet]="resultDetails"></ng-container>
          </ng-template>
        </e-tabitem>

        <e-tabitem>
          <ng-template #headerText>
            <div>Infos</div>
          </ng-template>
          <ng-template #content>
            <app-json-editor [content]="(results$|async)" [readOnly]="true"></app-json-editor>
          </ng-template>
        </e-tabitem>

      </e-tabitems>

    </ejs-tab>


  </div>

  <div class="details" *ngIf="results.total === 0">
    <ng-container [ngTemplateOutlet]="refreshButton"></ng-container>
  </div>

  <ng-template #resultDetails>
    <div class="details-content">
      <div class="item" (click)="displayNotDelivered()">
        Not Delivered / Processing : {{ results.total - results.statusCounts.delivered }}
      </div>
      <div class="item item-red" (click)="displayFailed()">
        Failed : {{ results.statusCounts?.failed || 0 }}
      </div>
      <div class="item item-red">
        Permanent Fail: {{ results.statusCounts?.permanent_fail || 0 }}
      </div>
      <div class="item item-red">
        Temporary Fail: {{ results.statusCounts?.temporary_fail || 0 }}
      </div>
      <app-email-status-details
        [campaignUuid]="campaignUuid"
        [waveUuid]="waveUuid"
      >
      </app-email-status-details>
    </div>

  </ng-template>


  <div class="loading-indicator p-4">
    <div *ngIf="!(isLoading$|async)" class="button">
      <ng-container [ngTemplateOutlet]="refreshButton"></ng-container>
    </div>
    <div *ngIf="(isLoading$|async)" class="text">
      <mat-icon>sync</mat-icon>
      Refreshing
    </div>

  </div>

  <ng-template #refreshButton>
    <button [disabled]="(isLoading$|async)" mat-stroked-button (click)="forceRefresh()">
      <mat-icon [inline]="true" style="font-size: 24px;">refresh</mat-icon> Refresh
    </button>
  </ng-template>

</ng-container>
